import React, { useCallback, useMemo } from 'react';

import { Stack } from '@lyearn/ui';
import QuestionText from '@/modules/corporate/modules/questions/fields/components/QuestionText';
import { QuizPlayerFieldProps } from '@/modules/corporate/modules/questions/fields/types';
import { MtfElement, MtfResponse } from '@/types/schema';

import { OptionsListItemTypeEnum } from '../../single-select/types';
import CorrectAnswers from '../QuestionReview/CorrectAnswers';
import { getElementListItemType } from '../utils';
import ElementsList from './components/ElementsList';

function Player(props: QuizPlayerFieldProps) {
  const { question, onChange, questionAttempt, correctAnswers, classes } = props;
  const mtfResponse = useMemo(
    () => questionAttempt?.submission?.mtfResponse || [],
    [questionAttempt?.submission?.mtfResponse],
  );
  const isQuestionSubmitted = Boolean(questionAttempt?.isSubmitted);
  const correctMtfPairings = correctAnswers?.correctMTFPairings;

  const correctAnswerCount = useMemo(
    () =>
      question.mtfComponent?.leftElements.filter(
        (element) =>
          getElementListItemType({
            element: element as MtfElement,
            isQuestionSubmitted,
            mtfResponse,
            correctMtfPairings,
            side: 'left',
          }).type === OptionsListItemTypeEnum.Correct,
      ).length,
    [correctMtfPairings, isQuestionSubmitted, mtfResponse, question.mtfComponent?.leftElements],
  );

  const showCorrectAnswers =
    isQuestionSubmitted &&
    correctMtfPairings &&
    question.mtfComponent?.leftElements?.length !== correctAnswerCount;

  const _onChange = useCallback(
    (mtfResponse: MtfResponse[]) => {
      onChange?.({ mtfResponse });
    },
    [onChange],
  );

  if (!question.mtfComponent) {
    return null;
  }

  return (
    <Stack direction="col">
      <QuestionText classes={{ container: classes?.question }} question={question} />
      <ElementsList
        correctAnswers={correctAnswers}
        mtfComponent={question.mtfComponent}
        mtfResponse={mtfResponse}
        questionAttempt={questionAttempt}
        onChange={_onChange}
      />
      {showCorrectAnswers ? (
        <CorrectAnswers
          className="mt-32"
          correctMtfPairings={correctMtfPairings}
          mtfComponent={question.mtfComponent}
        />
      ) : null}
    </Stack>
  );
}

export default Player;
